import { render } from "./Screen.vue?vue&type=template&id=9773395e&scoped=true"
import script from "./Screen.vue?vue&type=script&lang=js"
export * from "./Screen.vue?vue&type=script&lang=js"

import "./Screen.vue?vue&type=style&index=0&id=9773395e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9773395e"]])

export default __exports__